import { Space, Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import styled from 'styled-components';
import {
  EmptyStateContainer,
  EmptyState,
} from 'components/atoms/empty-state/empty-state';
import { Input, SearchInput } from 'components/atoms/input';
import { FilterBar } from 'components/molecules/filter-bar';
import { Table } from 'components/molecules/table';
import { SingleLineEllipsis } from 'components/styles';

const { Paragraph } = Typography;

interface ParagraphWithWidth extends ParagraphProps {
  width?: number;
}

export const LongText = styled(Paragraph)<ParagraphWithWidth>`
  margin-left: var(--spacing-03);
  width: ${(props) => `${props.width || '300'}px`};
  margin-bottom: 0;
  ${SingleLineEllipsis};
`;

export const ProjectNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const WithAvatarSpace = styled(Space)`
  .ant-space-item {
    margin-right: var(--spacing-05);
  }
`;

export const MoreActions = styled.div`
  display: flex;
  justify-content: center;
`;

export const SearchBar = styled(Input)`
  width: 250px;
`;
export const StyledTable = styled(Table)`
  .in-active {
    opacity: 0.4;
  }
  .ant-table-empty {
    .ant-table-cell {
      border: none !important;
    }
  }
`;

export const FilterBarWrapper = styled(FilterBar)`
  padding: var(--spacing-03) var(--spacing-07) var(--spacing-03);
`;

export const FilterBarSecondary = styled(FilterBar.Secondary)`
  gap: var(--spacing-05);
`;

export const ArchivedProjectsWrapper = styled.div`
  padding: 0 var(--spacing-05) 0;
`;

export const StyledSearchInput = styled(SearchInput)`
  .ant-btn {
    border: none;
  }
`;

export const EmptyStateWrapper = styled(EmptyStateContainer)`
  padding: 160px 50px;
  text-align: left;
`;

export const EmptyStateContent = styled(EmptyState)`
  color: var(--black-100);
`;
